import { Task } from '../api/types';

/** Forme attendue par PUT .../tasks/restore — un instantané de tâche sans id ni diagramId (voir backend ReplaceTasksDto). Partagé entre TaskTable et GanttChart : les deux vues doivent pouvoir annuler leurs propres modifications. */
export function toSnapshotItem(t: Task) {
  return {
    number: t.number,
    parentNumber: t.parentNumber,
    nameFr: t.nameFr,
    nameEn: t.nameEn,
    startDate: t.startDate,
    endDate: t.endDate,
    durationDays: t.durationDays,
    progressPct: t.progressPct,
    isClientMilestone: t.isClientMilestone,
    diagAuto: t.diagAuto,
    visible: t.visible,
    isMaster: t.isMaster,
    predecessorsText: t.predecessorsText,
    formatting: t.formatting,
  };
}
